/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_SpecsInputs */

const cs_property_specs = /** @type {(inputs: Property_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametry`)
};

const en_property_specs = /** @type {(inputs: Property_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specifications`)
};

/**
* | output |
* | --- |
* | "Specifications" |
*
* @param {Property_SpecsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_specs = /** @type {((inputs?: Property_SpecsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_SpecsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_specs(inputs)
	return cs_property_specs(inputs)
});